var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98612",
    "data-name": "Group 98612",
    transform: "translate(-152 -553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_909",
    "data-name": "Ellipse 909",
    transform: "translate(152 553)",
    fill: "#fff",
    stroke: "#00057d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "checkout",
    transform: "translate(161.65 562.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215614",
    "data-name": "Path 215614",
    d: "M55.709,28.983H37.8c-.341,0-.339-.37-.146-.537l3.982-1.355H54.4a.307.307,0,0,0,.293-.3l.16-8.236a.3.3,0,0,0-.25-.3l-2.817-.424a5.89,5.89,0,0,1-10.43-1.564l-1.878-.281.008,0-.548-3.421A.753.753,0,0,0,38.2,12H35.01v1.5h2.6l2.678,12.714L36.68,27.275A1.844,1.844,0,0,0,37.8,30.533h3.088a1.478,1.478,0,0,0-.267.88,1.653,1.653,0,0,0,3.307,0,1.489,1.489,0,0,0-.267-.884h6.349a1.478,1.478,0,0,0-.267.88,1.653,1.653,0,0,0,3.307,0,1.489,1.489,0,0,0-.267-.884H55.71V28.983Z",
    transform: "translate(-34.01 -10.088)",
    fill: "#00057d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215615",
    "data-name": "Path 215615",
    d: "M192.986,0a4.363,4.363,0,1,0,4.368,4.363A4.37,4.37,0,0,0,192.986,0Zm-.27,6.444a.771.771,0,0,1-1.135-.031l-1.315-1.565,1.163-.981.765.91,2.293-2.443,1.108,1.043Z",
    transform: "translate(-180.04)",
    fill: "#00057d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus3);
export default __webpack_public_path__ + "static/media/status3.6c16adbdb2ef625c47188ef023ab751b.svg";
export { ForwardRef as ReactComponent };